import CHALLENGES_ROUTES from "@/challenges/constants/routes.constants";

const getChallengesBreadcrumbsLinks = (currentContent) => {
  const links = [
    {
      href: CHALLENGES_ROUTES.HOME.route,
      contents: CHALLENGES_ROUTES.HOME.contents,
    },
    {
      href: CHALLENGES_ROUTES.LANDING.route,
      contents: CHALLENGES_ROUTES.LANDING.contents,
    },
  ];

  if (currentContent) {
    links.push({
      href: "#",
      contents: currentContent,
    });
  }

  return links;
};

export default getChallengesBreadcrumbsLinks;
